import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';

import Layout from '../../shared/components/layouts/MainLayout';
import AlertsList from '../components/AlertsList';
import EmptyState from '../components/EmptyState';
import {fetchAlerts, deleteAlert} from '../actions';
import { openModal } from "../../shared/actions";
import EditAlertModal from '../components/EditAlertModal';
import Prompt from '../../shared/components/notices/Prompt';
import Pagination from '../../shared/components/Pagination';
import {debounce} from 'lodash'

import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../shared/constants/SegmentEvents';
import {isNil} from 'lodash';
import ArrayFormatters from '../../../utils/arrayFormatters';

class ProjectFinderAlerts extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedAlert: {
        id: null,
        frequency: null,
        filters: {
          keyword: "",
          region: "",
          min_amount: "",
          max_amount: "",
        }
      },
      deletePrompt: false,
    }

    this.deletePromptText = this.deletePromptText.bind(this);
    this.showEditModal = this.showEditModal.bind(this);
    this.showDeletePrompt = this.showDeletePrompt.bind(this);
    this.renderDeletePrompt = this.renderDeletePrompt.bind(this);
    this.handlePageClick = debounce(this.handlePageClick.bind(this), 300);
    this.handlePreviousButtonClick = debounce(this.handlePreviousButtonClick.bind(this), 300);
    this.handleNextButtonClick = debounce(this.handleNextButtonClick.bind(this), 300);
  }

  componentWillMount() {
    this.props.fetchAlerts(this.props.user.email, this.props.alertsCurrentPage);
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(PageViewName.ALERTS_MANAGER_VIEWED);
  }

  showEditModal(alert) {
    this.props.openModal("editAlertModal");
    this.setState({selectedAlert: alert, deletePrompt: false});
  }

  showDeletePrompt(alert) {
    this.setState({ deletePrompt: true, selectedAlert: alert })
  }

  destroyAlert() {
    this.props.deleteAlert(this.state.selectedAlert.id)
    this.setState({ deletePrompt: false});
    segmentEventTracker.trackEvent(TrackEventName.PROJECT_FILTER_DELETED, this.state.selectedAlert);
  }

  deletePromptText() {
    const {filters} = this.state.selectedAlert;
    const keyword = filters["keyword"] || "Projects"
    const {region, regions } = filters;

    const regionsValue = isNil(regions) ? [region] : regions;

    return `Are you sure you want to delete alert for ${keyword} in ${ArrayFormatters.toWords(regionsValue) || "All regions"}`
  }

  renderDeletePrompt() {
    return(
      <Prompt
        open={this.state.deletePrompt}
        onCancel={() => this.setState({deletePrompt: false})}
        onConfirm={() => this.destroyAlert()}
        copy={this.deletePromptText()}
      />
    );
  }

  handlePageClick(value) {
    this.setState({loading: true});
    this.props.fetchAlerts(this.props.user.email, value);
  }

  handlePreviousButtonClick() {
    const page = Number(this.props.alertsCurrentPage) - 1;
    this.setState({loading: true});
    this.props.fetchAlerts(this.props.user.email, page);
  }

  handleNextButtonClick() {
    const page = Number(this.props.alertsCurrentPage) + 1;
    this.setState({loading: true});
    this.props.fetchAlerts(this.props.user.email, page);
  }

  render() {
    const {alerts, alertsCurrentPage, alertsTotalCount, alertsTotalPages} = this.props;

    if (this.props.loading)
      return (
        <Layout>
          <div className="loading" />
        </Layout>
      );

    if (alerts.length === 0) {
      return (
        <Layout gridClassName='_marginTop--xxlarge-tabletUp --wide'>
          <EmptyState />
        </Layout>
      );
    }

    return (
      <Fragment>
        <EditAlertModal
          {...this.state.selectedAlert}
        />
        {this.renderDeletePrompt()}
        <Layout gridClassName='_marginTop--xxlarge-tabletUp --wide'>
          <AlertsList
            alerts={alerts}
            caption="Project Finder Alerts"
            onClickUpdateButton={this.showEditModal}
            onClickDeleteButton={this.showDeletePrompt}
          />
          <Pagination
            totalPages={alertsTotalPages}
            currentPage={alertsCurrentPage}
            totalCount={alertsTotalCount}
            handlePageClick={this.handlePageClick}
            handlePreviousButtonClick={this.handlePreviousButtonClick}
            handleNextButtonClick={this.handleNextButtonClick}
          />
        </Layout>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    alerts: state.alerts,
    alertsCurrentPage: state.alertsCurrentPage,
    alertsTotalPages: state.alertsTotalPages,
    alertsTotalCount: state.alertsTotalCount,
    loading: state.shared.ui.loading.default,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchAlerts: (email, page) => dispatch(fetchAlerts(email, page)),
    openModal: () => dispatch(openModal('editAlertModal')),
    deleteAlert: (id) => dispatch(deleteAlert(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectFinderAlerts);



// WEBPACK FOOTER //
// ./src/features/alertsManager/containers/ProjectFinderAlerts.js